import { render, staticRenderFns } from "./DownTable.vue?vue&type=template&id=bbc228fc&"
import script from "./DownTable.vue?vue&type=script&lang=js&"
export * from "./DownTable.vue?vue&type=script&lang=js&"
import style0 from "./DownTable.vue?vue&type=style&index=0&id=bbc228fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports